import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import UserInfoSection from '../../profile/UserInfoSection';
import UserJourneySection from '../../profile/UserJourneySection';
import useInterveneSx from '../../../hooks/useInterveneSx';

export default function ProfileTabContent({
  activeUser,
  journey,
  isLoadingProfile,
}) {
  const interveneSx = useInterveneSx();
  const styles = interveneSx.profile;
  const [expandedPanel, setExpandedPanel] = useState('info');

  if (!activeUser?.phone_number) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Select a conversation to view profile.
      </Typography>
    );
  }

  const infoExpanded = expandedPanel === 'info';
  const journeyExpanded = expandedPanel === 'journey';

  return (
    <Box sx={{ position: 'relative', minHeight: 120 }}>
      {isLoadingProfile && (
        <Box sx={styles.loadingOverlay}>
          <CircularProgress size={28} />
        </Box>
      )}

      <Accordion
        expanded={infoExpanded}
        onChange={() => setExpandedPanel((prev) => (prev === 'info' ? null : 'info'))}
        disableGutters
        elevation={0}
        sx={[styles.accordion, infoExpanded && styles.accordionFill]}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="small" />}
          sx={styles.accordionSummary}
        >
          <Box sx={styles.accordionIconWrap}>
            <AccountCircleIcon sx={styles.accordionIcon} />
          </Box>
          <Typography sx={styles.accordionTitle}>User Info</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={[styles.accordionDetails, infoExpanded && styles.accordionDetailsScroll]}
        >
          <UserInfoSection userDetails={activeUser} />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={journeyExpanded}
        onChange={() => setExpandedPanel((prev) => (prev === 'journey' ? null : 'journey'))}
        disableGutters
        elevation={0}
        sx={[styles.accordion, journeyExpanded && styles.accordionFill]}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="small" />}
          sx={styles.accordionSummary}
        >
          <Box sx={styles.accordionIconWrap}>
            <ModeOfTravelIcon sx={styles.accordionIcon} />
          </Box>
          <Typography sx={styles.accordionTitle}>Customer Journey</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={[styles.accordionDetails, journeyExpanded && styles.accordionDetailsScroll]}
        >
          {journeyExpanded && <UserJourneySection journey={journey} />}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
